import React from "react";

interface WhatsAppIconProps {
  className?: string;
  size?: number;
  color?: string;
}

export const WhatsAppIcon: React.FC<WhatsAppIconProps> = ({
  className = "",
  size = 18,
  color = "#008B37",
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 18 18"
      fill="none"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.4208 3.57142C12.9827 2.13946 11.0701 1.35046 9.03223 1.34973C4.83301 1.34973 1.41548 4.74802 1.41402 8.92513C1.41329 10.2605 1.76432 11.5638 2.43095 12.7125L1.3501 16.6386L5.3886 15.5851C6.50122 16.1889 7.75412 16.5067 9.02895 16.5071H9.03223C13.2307 16.5071 16.6487 13.1084 16.6501 8.9313C16.6508 6.90689 15.8593 5.00376 14.4208 3.57179V3.57142ZM9.03223 15.2277H9.02968C7.89365 15.2273 6.77922 14.9236 5.80686 14.35L5.57563 14.2135L3.17904 14.8386L3.81864 12.5148L3.66815 12.2766C3.03439 11.274 2.69943 10.1152 2.70016 8.92551C2.70162 5.45383 5.54202 2.62913 9.03482 2.62913C10.726 2.62986 12.3157 3.28554 13.5113 4.47594C14.7068 5.66598 15.3647 7.24835 15.364 8.93059C15.3625 12.4026 12.5221 15.2273 9.03223 15.2273V15.2277ZM12.5053 10.5119C12.315 10.4171 11.3792 9.95932 11.2045 9.89613C11.0299 9.8329 10.9032 9.80133 10.7764 9.99093C10.6497 10.1806 10.2848 10.607 10.1737 10.7331C10.0627 10.8595 9.95163 10.8751 9.76131 10.7803C9.57104 10.6855 8.95773 10.4857 8.23046 9.84089C7.66466 9.33887 7.28255 8.71917 7.17154 8.52953C7.06048 8.33993 7.15985 8.23748 7.25479 8.1434C7.34026 8.0584 7.44511 7.92218 7.54043 7.81174C7.6358 7.7013 7.66721 7.62214 7.73075 7.49606C7.79433 7.36965 7.76254 7.25925 7.71507 7.16441C7.66755 7.06961 7.28696 6.13783 7.12806 5.75896C6.97353 5.3899 6.81649 5.44003 6.69995 5.43386C6.5889 5.4284 6.46217 5.42732 6.33505 5.42732C6.20793 5.42732 6.00189 5.47454 5.8273 5.66416C5.65271 5.85376 5.16103 6.31183 5.16103 7.24323C5.16103 8.17463 5.84303 9.07517 5.93835 9.20159C6.03368 9.328 7.28072 11.2398 9.19003 12.0601C9.6441 12.2551 9.99876 12.3717 10.2753 12.4589C10.7312 12.6031 11.1461 12.5828 11.4741 12.5341C11.8398 12.4796 12.6003 12.076 12.7588 11.634C12.9173 11.1919 12.9173 10.8126 12.8698 10.7338C12.8224 10.655 12.6953 10.6074 12.5049 10.5126L12.5053 10.5119Z"
        fill={color}
      />
    </svg>
  );
};
